import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

// Circular initials avatar when assigned; a dashed "+" circle when not. With
// `canMaintain`, both states are clickable and emit `assign` with the clicked
// element (the anchor for the assignment popover) — assigning when unassigned,
// reassigning when assigned. Read-only users see a static avatar or dash.
@Component({
  selector: 'app-owner-avatar',
  template: `
    <button *ngIf="initials && canMaintain" type="button" class="avatar" [title]="name || ''"
            (click)="onClick($event)">{{ initials }}</button>
    <span *ngIf="initials && !canMaintain" class="avatar" [title]="name || ''">{{ initials }}</span>

    <button *ngIf="!initials && canMaintain" type="button" class="avatar unassigned"
            [title]="'@issueAssign' | translate" (click)="onClick($event)">+</button>
    <span *ngIf="!initials && !canMaintain" class="avatar unassigned readonly"
          [title]="'@issueUnassigned' | translate">–</span>
  `,
  styles: [`
    :host { display: inline-flex; align-items: center; justify-content: center; }
    .avatar {
      width: 22px; height: 22px; border-radius: 50%;
      display: inline-flex; align-items: center; justify-content: center;
      font-size: 10px; font-weight: 500; color: #fff; background: #1565c0;
      border: none; padding: 0;
    }
    button.avatar { cursor: pointer; }
    button.avatar:hover { box-shadow: 0 0 0 2px #e3f2fd; }
    button.avatar:focus-visible { outline: 2px solid #2962ff; outline-offset: 1px; }
    /* Nobody yet is a real state, so it is a dashed ring rather than an absence. Matches
       the sheet row's own empty avatar, which is the same idea in another file. */
    .avatar.unassigned {
      background: #fff; color: #9e9e9e;
      border: 1px dashed #bdbdbd; font-size: 14px; font-weight: 400;
    }
    button.avatar.unassigned:hover { background: #e3f2fd; border-color: #1565c0; color: #1565c0; box-shadow: none; }
    .avatar.unassigned.readonly { cursor: default; }
  `],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OwnerAvatarComponent {
  @Input() initials: string | null = null;
  @Input() name: string | null = null;
  @Input() canMaintain = false;
  @Output() assign = new EventEmitter<HTMLElement>();

  onClick(event: MouseEvent): void {
    event.stopPropagation();
    this.assign.emit(event.currentTarget as HTMLElement);
  }
}
